export default __webpack_public_path__ + "static/media/Podium.921abfc9.svg";